import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import TextField from "../../fields/TextField";
import IBANTextField from "../../fields/IBANTextField";

function BankingForm({ control, setError, clearErrors }) {
  return (
    <Grid container spacing={3}>
      <Grid item lg={12} xs={12}>
        <TextField
          fullWidth
          variant="outlined"
          margin="normal"
          control={control}
          required
          id="creditorName"
          label="Ihr Name"
          name="creditorName"
          autoComplete="creditorName"
          autoFocus
        />
      </Grid>
      <Grid item lg={12} xs={12}>
        <IBANTextField
          control={control}
          name={"creditorIBAN"}
          label={"IBAN"}
          type={"text"}
          variant="outlined"
          required={true}
          fullWidth
          setError={setError}
          clearErrors={clearErrors}
        />
      </Grid>
      <Grid item lg={12} xs={12}>
        <TextField
          fullWidth
          variant="outlined"
          margin="normal"
          control={control}
          required
          id="creditorBIC"
          label="Ihre BIC"
          name="creditorBIC"
          autoComplete="creditorBIC"
        />
      </Grid>
      <Grid item lg={12} xs={12}>
        <TextField
          fullWidth
          variant="outlined"
          margin="normal"
          control={control}
          required
          id="creditorId"
          label="Gläubiger ID"
          name="creditorId"
          autoComplete="creditorId"
        />
      </Grid>
    </Grid>
  );
}

BankingForm.propTypes = { props: PropTypes.object };

export default BankingForm;
